(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prop-types"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["prop-types", "react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["@transferwise/comparison-components/comparison-table-hero-v2"] = factory(require("prop-types"), require("react"), require("react-dom"));
	else
		root["@transferwise/comparison-components/comparison-table-hero-v2"] = factory(root["PropTypes"], root["React"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__6886__, __WEBPACK_EXTERNAL_MODULE__4119__, __WEBPACK_EXTERNAL_MODULE__9545__) {
return 